export default __webpack_public_path__ + "static/media/icon_privacy.4e20f126.svg";